

/**
 * 
 */
export class RessourceModel {

    groupeOrigine: string;
    mtRessource: number;
}
